import { Component } from '@angular/core';

@Component({
  selector: 'app-topic-teaser-demo',
  templateUrl: './topic-teaser-demo.component.html',
})
export class TopicTeaserDemoComponent {}
